<template>
   <v-container fluid class="e-min-height pa-0" >
    <HeaderFill :router="`/practica/avanzada/${this.idUnidad}`" :back="false" title="Práctica Intermedia"/>
    <v-container fluid class="px-0" style="padding-top: 56px;">
      <v-layout row wrap class="fill-height">
        <v-flex xs12>
          <router-view></router-view>
        </v-flex>
        <Correcto/>
        <InCorrecto/>
      </v-layout>
    </v-container>
  </v-container>
</template>
<script>
export default {
  props: ['idUnidad']
}
</script>
